export default __webpack_public_path__ + "static/telegramSystem-91350ef0c0b33e6176706a41600f48d4.png";